import { createAsyncAction, createAction } from 'typesafe-actions';
import type { Organization } from '@nimbly-technologies/nimbly-common';

import * as types from './organizations.actionsTypes';

const fetchOrganizations = createAsyncAction(
	types.GET_ORGANIZATION_REQUEST,
	types.GET_ORGANIZATION_SUCCESS,
	types.GET_ORGANIZATION_FAILURE,
	types.GET_ORGANIZATION_CANCEL,
)<undefined, { data: any }, { error: string }, undefined>();

const fetchAllOrganizations = createAsyncAction(
	types.GET_ALL_ORGANIZATIONS_REQUEST,
	types.GET_ALL_ORGANIZATIONS_SUCCESS,
	types.GET_ALL_ORGANIZATIONS_FAILURE,
	types.GET_ALL_ORGANIZATIONS_CANCEL,
)<undefined, { data: Organization[] }, { error: string }, undefined>();

const resetOrganization = createAction(types.RESET_ORGANIZATION)();

export { fetchOrganizations, fetchAllOrganizations, resetOrganization };
